import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/CompanyDescriptionExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialInformationExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_MARKET_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/ProductsExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_RISKS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/RisksExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/TeamExecSummary/utils/form';

import { ol } from '../helpers';

const COMPANY_DESCRIPTION_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.HISTORY]: {
    name: 'Historia de la empresa',
    instruction:
      'Presente una breve descripción del origen de su empresa y de sus primeros hitos, incluyendo la necesidad del mercado que dio lugar a su creación. Destaque los logros iniciales, como el registro de la empresa, la obtención de licencias o el desarrollo del primer prototipo.',
    exampleOne:
      'En 2020, la empresa lanzó su primer modelo de tractor de orugas, revolucionando la agricultura en terrenos difíciles gracias a una tracción y flotación superiores.',
    exampleTwo:
      'En 2021, la plataforma lingüística lanzó su función de traducción basada en inteligencia artificial, transformando la comunicación multilingüe.',
  },

  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.RESOURCES_AND_ASSETS]: {
    name: 'Principales recursos y activos',
    instruction:
      'Clasifique los activos de la empresa en categorías como instalaciones físicas, equipos, inventario y activos intangibles, incluyendo tecnología, propiedad intelectual y valor de marca. Proporcione también una valoración general de estos activos.',
    exampleOne:
      'Los principales recursos y activos de la empresa incluyen modernas instalaciones de producción, maquinaria y tecnología de última generación, un equipo altamente cualificado, propiedad intelectual y alianzas estratégicas. Las instalaciones de fabricación cuentan con líneas de producción avanzadas y sistemas de control de calidad que permiten fabricar maquinaria agrícola de alta calidad con la máxima eficiencia.',
    exampleTwo:
      'Los principales recursos y activos de la empresa incluyen tecnología avanzada de inteligencia artificial, una amplia red de traductores altamente cualificados, sólidos protocolos de seguridad, relaciones consolidadas con los clientes y derechos de propiedad intelectual.',
  },

  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.COMPANY_OWNERS]: {
    name: 'Propietarios de la empresa',
    instruction:
      'Asegúrese de indicar el nombre legal completo de los propietarios de la empresa. Verifique cuidadosamente la ortografía y el formato para evitar cualquier error.',
    exampleOne: '1. John Johnson\n2. Oliver Smith',
    exampleTwo: '1. John Doe',
  },
};
const PRODUCTS_OR_SERVICES_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE]: {
    name: 'Valor del producto o servicio y problema que resuelve',
    instruction:
      'Explique claramente la propuesta de valor principal de su producto o servicio y el problema que resuelve. Describa los beneficios para los clientes y el impacto práctico que genera.',
    exampleOne:
      'Al minimizar la compactación del suelo y maximizar la tracción, los tractores de orugas permiten a los agricultores trabajar con mayor eficiencia, completando sus tareas con mayor rapidez y precisión.',
    exampleTwo:
      'La plataforma de servicios lingüísticos facilita una comunicación fluida entre diferentes idiomas, permitiendo a los clientes llegar a audiencias internacionales y ampliar eficazmente su alcance.',
  },
};

const MARKET_AND_CUSTOMERS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS]: {
    name: 'Dinámica del mercado',
    instruction:
      'Describa la dinámica del mercado, incluyendo los factores que influyen en la oferta, la demanda, la competencia y la estructura del sector. Indique la tasa de crecimiento anual compuesta (CAGR) del mercado objetivo. Explique las tendencias actuales, como los cambios en las preferencias de los consumidores, los avances tecnológicos y las mejores prácticas del sector. Destaque cómo estos factores afectan a la empresa y su capacidad de adaptación.',
    exampleOne:
      'Durante la última década, el mercado ha registrado una tasa de crecimiento anual compuesta (CAGR) aproximada del 5 %, alcanzando un valor superior a los 200 000 millones de USD en 2020. Este crecimiento ha sido impulsado por el aumento de la mecanización en los países en desarrollo, donde la adopción de prácticas agrícolas modernas se ha acelerado para responder al incremento de la demanda de alimentos.',
    exampleTwo:
      'El mercado de los servicios lingüísticos experimenta un sólido crecimiento impulsado por la globalización, la digitalización y el aumento de la comunicación internacional. Entre las principales tendencias destacan la creciente demanda de soluciones de traducción basadas en inteligencia artificial, la expansión hacia mercados emergentes, la adopción de plataformas lingüísticas en la nube y un mayor enfoque en la diversidad lingüística y la localización.',
  },

  [EXECUTIVE_SUMMARY_MARKET_NAMES.COMPETITION_PLAN]: {
    name: 'Estrategia competitiva',
    instruction:
      'Describa la estrategia competitiva de la empresa y explique cómo se diferenciará de sus competidores. Destaque sus principales ventajas competitivas, como la innovación, la política de precios o la experiencia del cliente. Explique su posicionamiento en el mercado y los principios estratégicos que guían su desarrollo.',
    exampleOne:
      'La empresa invierte de forma continua en investigación y desarrollo para mejorar sus productos, mantener el liderazgo tecnológico y responder a las necesidades cambiantes de los clientes. Asimismo, prioriza la satisfacción del cliente ofreciendo un servicio y un soporte excepcionales durante todo el ciclo de vida de la relación comercial.',
    exampleTwo:
      'La empresa busca diferenciarse mediante la innovación, una tecnología superior, un servicio personalizado y una gran capacidad de adaptación. La mejora continua de sus soluciones basadas en inteligencia artificial, la ampliación de la cobertura lingüística y una experiencia excepcional para el cliente le permitirán mantenerse por delante de la competencia y consolidar su posición como líder del sector de los servicios lingüísticos.',
  },
};
const ORGANIZATION_AND_TEAM_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS]: {
    name: 'Miembros clave del equipo',
    instruction: 'Enumere los principales miembros del equipo.',
    exampleOne:
      'Los principales participantes del proyecto son John Johnson, Oliver Smith, Isabella Brown y Henry Miller.',
    exampleTwo: 'Los principales participantes del proyecto son John Johnson, Mary Wilson y Liam Anderson.',
  },
};

const FINANCIAL_INFORMATION_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.AVERAGE_ANNUAL_PROFIT]: {
    name: 'Beneficio anual histórico',
    instruction:
      'Calcule e indique el beneficio anual promedio sumando el beneficio neto de los últimos tres años y dividiéndolo entre tres. Este valor debe ser preciso y reflejar de forma consistente el desempeño financiero de la empresa durante dicho período.',
    exampleOne: '',
    exampleTwo: '',
  },

  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.ASSETS_SIZE]: {
    name: 'Valor total de los activos',
    instruction:
      'Para calcular el valor total de sus activos:' +
      ol([
        'Enumere todos los activos, incluidos efectivo, inversiones, bienes inmuebles y equipos.',
        'Determine el valor de mercado actual de cada activo.',
        'Sume todos los valores para obtener el valor total de los activos.',
      ]) +
      'Utilice la siguiente fórmula: Activos Totales = Efectivo + Inversiones + Bienes Inmuebles + Equipos + Otros Activos.',
    exampleOne: '',
    exampleTwo: '',
  },

  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.PROJECTED_ANNUAL_PROFIT]: {
    name: 'Beneficio anual proyectado',
    instruction:
      'Para calcular el beneficio anual proyectado para los próximos tres años:' +
      ol([
        'Estime los ingresos anuales en función de las previsiones de ventas y las tendencias de precios.',
        'Reste el coste de los bienes vendidos (COGS) para obtener el beneficio bruto.',
        'Descuente los gastos operativos, los impuestos y los intereses.',
        'Considere el crecimiento esperado, las condiciones del mercado y las inversiones o cambios de costes previstos.',
      ]),
    exampleOne: '',
    exampleTwo: '',
  },

  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.RETURN_ON_INVESTMENT]: {
    name: 'Retorno de la inversión',
    instruction:
      'Para calcular el retorno de la inversión (ROI):' +
      ol([
        'Determine el beneficio neto generado por la inversión.',
        'Divida el beneficio neto entre el coste inicial de la inversión.',
        'Multiplique el resultado por 100 para expresarlo como porcentaje.',
      ]) +
      'Utilice la siguiente fórmula: ROI = (Beneficio Neto / Coste Inicial de la Inversión) × 100.',
    exampleOne: '',
    exampleTwo: '',
  },

  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.INTERNAL_RATE_OF_RETURN]: {
    name: 'Tasa interna de retorno',
    instruction:
      'Para calcular la tasa interna de retorno (TIR):' +
      ol([
        'Reúna los datos de la inversión inicial y de los flujos de caja.',
        'Determine la tasa que hace que el valor actual neto (VAN) de los flujos de caja sea igual a cero.',
        'Utilice un software financiero para calcular la TIR.',
      ]),
    exampleOne: '',
    exampleTwo: '',
  },
};
const FUNDING_DIRECTIONS_INSTRUCTIONS = {
  name: 'Destino de los fondos',
  instruction:
    'Especifique la distribución del presupuesto para cada finalidad: investigación y desarrollo (I+D), marketing, capital de trabajo, construcción y adquisición de equipos.',
  exampleOne: '',
  exampleTwo: '',
};

const FINANCING_NEEDS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },

  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },

  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },

  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },

  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },

  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
};

const RISKS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS]: {
    name: 'Principales riesgos del proyecto',
    instruction:
      'Describa los principales riesgos del proyecto, como la evolución del mercado, los desafíos tecnológicos, los cambios regulatorios y las incertidumbres financieras. Evalúe el impacto potencial de cada riesgo sobre el éxito del proyecto.',
    exampleOne: ol([
      'Complejidades técnicas imprevistas durante el proceso de desarrollo.',
      'La volatilidad del mercado y los cambios en las preferencias de los clientes representan otro riesgo, ya que las variaciones en las condiciones económicas, las políticas regulatorias o el entorno competitivo pueden afectar la demanda del producto o modificar la dinámica del mercado.',
    ]),
    exampleTwo:
      'Los principales riesgos del proyecto incluyen las disrupciones tecnológicas, las amenazas de ciberseguridad, la volatilidad del mercado, los cambios regulatorios y la competencia. Además, la dependencia de proveedores externos o la escasez de talento especializado pueden representar desafíos adicionales.',
  },

  [EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES]: {
    name: 'Medidas de mitigación de riesgos',
    instruction:
      'Describa las medidas previstas para mitigar los riesgos, como la diversificación, los seguros, los fondos de contingencia o las alianzas estratégicas. Explique también cómo se realizará el seguimiento continuo de los riesgos y cómo la capacidad de adaptación del equipo contribuye a la eficacia de la estrategia de mitigación.',
    exampleOne: ol([
      'La empresa aplica sólidos procedimientos de gestión de riesgos, realiza estudios de mercado exhaustivos y mantiene canales de comunicación abiertos con las partes interesadas para identificar posibles problemas de forma temprana e implementar medidas preventivas.',
      'La empresa mantiene planes de contingencia y la flexibilidad necesaria en la ejecución del proyecto para adaptarse a circunstancias cambiantes y garantizar el éxito de su implementación.',
    ]),
    exampleTwo:
      'Las estrategias de mitigación incluyen:' +
      ol([
        'Diversificar las fuentes de ingresos.',
        'Mantenerse al día con las tendencias del sector.',
        'Aplicar medidas sólidas de ciberseguridad y protección de la información.',
      ]),
  },
};

export const EXECUTIVE_SUMMARY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: COMPANY_DESCRIPTION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: PRODUCTS_OR_SERVICES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: MARKET_AND_CUSTOMERS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: ORGANIZATION_AND_TEAM_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: FINANCIAL_INFORMATION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCING_NEEDS]: FINANCING_NEEDS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.RISKS]: RISKS_INSTRUCTIONS,
};
